import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useSecurity } from "~/components/Hooks";
import { SelectTrackingRecordDate } from "~/components/SelectDate/SelectTrackingRecordDate";
import { getConfigOption } from "~/store/selectors/selector.configOptions";
import { getExpenseById } from "~/store/selectors/selector.expenses";
import { getProjectById } from "~/store/selectors/selector.projects";

export const SelectExpenseDate = ({ expenseId, projectId, onChange }) => {
  const can = useSecurity();

  const expense = useSelector((state) => getExpenseById(state, expenseId));

  const project = useSelector((state) => getProjectById(state, projectId));

  const canTrackForOtherUsers = can(["can_track_expense_for_others"], project);

  const backtrackMaxDays = useSelector((state) => getConfigOption(state, "backtrack_expense_max_days"));

  return (
    <SelectTrackingRecordDate
      backtrackMaxDays={backtrackMaxDays}
      canTrackForOther={canTrackForOtherUsers}
      startDate={expense?.created_on}
      selectedDate={expense?.record_date}
      onChange={onChange}
    />
  );
};

SelectExpenseDate.propTypes = {
  expenseId: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  onChange: PropTypes.func,
};
